import React from 'react'

function Download(props) {
  return (
    <button className='hoverButton'><a href={props.file} download={props.fileName} >Download {props.things}</a></button>
  )
}

export default Download